import React from 'react';
import {
  Heading,
  Caption,
  Container,
  headerCaptionProps
} from './HeaderCaption.styles';

const HeaderCaption = ({
  width = '',
  color = '#fff',
  textAlign = 'center',
  heading,
  caption,
  headingLength = '100%',
  headingMargin = '',
  headingSize = '15px',
  headingColor = '',
  captionLength = '100%',
  captionMargin = '',
  captionSize = '16px',
  captionColor = '',
  marginTop = '',
  alignItems = 'center',
  justifyContent = 'center',
  flexDirection = 'column',
  showCaption = true,
  showHeading = true,
  children,
  showHeadingRightContent,
  renderIcon,
  headingJustify,
  headingAlign,
  headingFlex,
  headingDisplay
}: headerCaptionProps) => {
  return (
    <Container
      alignItems={alignItems}
      justifyContent={justifyContent}
      flexDirection={flexDirection}
      width={width}
      color={color}
      marginTop={marginTop}
    >
      {children}
      {
        showHeading && (
        <Heading
          headingSize={headingSize}
          headingLength={headingLength}
          textAlign={textAlign}
          headingMargin={headingMargin}
          headingColor={headingColor}
          headingJustify={headingJustify}
          headingAlign={headingAlign}
          headingFlex={headingFlex}
          headingDisplay={headingDisplay}
        >
          <h1>{heading}</h1>
          {showHeadingRightContent?.()}
        </Heading>
        )
      }
      {showCaption && (
        <Caption
          captionSize={captionSize}
          captionLength={captionLength}
          textAlign={textAlign}
          captionMargin={captionMargin}
          captionColor={captionColor}
        >
          <p>{caption}</p>
        </Caption>
      )}
      {renderIcon?.()}
    </Container>
  );
};

export default HeaderCaption;
